// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-col-24[data-v-31e081b2] {\n  margin-top: 18px;\n}", ""]);
// Exports
module.exports = exports;
